<template>
    <div id="pageTab" class="tags-view-container" v-if="DSTTagsList.length>=1">
        <a-tabs v-model="activeKey" hide-add type="editable-card" size="small" @edit="onEdit">
            <a-tab-pane v-for="pane in DSTTagsList"
                        :key="pane.url+'-'+ (pane.query ? pane.query:'{}')"
                        :tab="pane.name"
                        :closable="pane.closable"></a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>

    export default {
        data() {
            return {}
        },
        mounted() {

        },
        computed: {
            activeKey: {
                get() {
                    return this.$route.name + '-' + JSON.stringify(this.$route.query)
                },
                set(val) {
                    let key = val.split('-');
                    const first = key.shift()
                    const last = key.join('-')
                    this.$router.push({name: first, query: JSON.parse(last)})
                }
            },
            DSTTagsList: {
                get() {
                    return this.$store.state.DSTTagsList
                },
                set(val) {
                    this.$store.commit("updateDSTTagsList", val);
                }
            },
        },
        methods: {
            onEdit(targetKey, action) {
                // console.log(targetKey)
                let data = targetKey.split('-')
                let list = JSON.parse(JSON.stringify(this.DSTTagsList))

                let index = null

                let first = data.shift()
                let last = data.join('-') === '{}' ? undefined : data.join('-')

                // console.log(first, last)

                for (let i = 0; i < list.length; i++) {

                    if (last) {
                        if (list[i].url === first && list[i].query == last) {
                            index = i
                        }
                    } else {
                        if (list[i].url === first) {
                            index = i
                        }
                    }
                }

                if (index !== null) {
                    list.splice(index, 1);
                    this.DSTTagsList = list
                }
            },

        },
    }
</script>

<style>
    #pageTab .ant-tabs-tab.ant-tabs-tab-active {
        line-height: 26px;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAiCAYAAACqVHINAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkU5RDVEQzRFOTE5RTExRUFBOEYwQjhGQjAxQkM0NjI2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkU5RDVEQzRGOTE5RTExRUFBOEYwQjhGQjAxQkM0NjI2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTlENURDNEM5MTlFMTFFQUE4RjBCOEZCMDFCQzQ2MjYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTlENURDNEQ5MTlFMTFFQUE4RjBCOEZCMDFCQzQ2MjYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4k6rIqAAACDUlEQVR42rSWSUvDQBTHp0naaNt0y9bGqtWKKIobbnjxoIKIG7bgQTwVBBFv3rx69At4UgQRFfdWPDhevHnw27hV2/iiF+s6M0kHHmGSvP76/897k3GZpomcHFvHuBUuixDTEIZ1z+UkBABr3kpxta0xgWoMFXkrxI8HFsSJ2Dy6Wr+8uTOfnvPm11HyYrHIFgBYObu+NfMvrybMv0WJXUUG57ZPsMhz3NPkUD+SfJU/viN8njCuTqah1kB+APyWXwpho2SSAPkr15aSnVNcDwq6wkHpz1y7SlLVMe3fPLtr8gFBFBAayu45jkOz9cmhwL95dpTMxAlUOABR6SGklL0s1itEz6ASDhHlsCqZMnQVtlcXUQ7HuOGmraoiHdR9cpDDEY/bPaLIYeK+YrFr0tAVcMpFbC+LXTNVUY0qgUrJYQ4H3IIwoakRqnKnVTIW1WTEcRy7EoK/l363irJrie06usBenudTmipTb6Q0ukd1AAg8T10pHF1VqUydSwQBq0RY7LmoppQPAmNYUyIIyreskNl4TGc+WXIEVi1Ift98PKaVBwKANJTtRm9HC3UDEkEAsATlejDQ3Y6CAcnWQVx4ePk0AeR+FjdbR/+g5F/u6WxFAb/P9mlfgB/1wrUaoh9iXBQ96aZkAtXVVNmyqAQiR+T7/PMjCoeCyOro9w3Q+lbAF6lQKDgCeRNgAHy9Fu5l0ocTAAAAAElFTkSuQmCC), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAiCAYAAACqVHINAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkU5N0ZFMDRCOTE5RTExRUE5NjIzRTU2OTQ2MEYzNzlFIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkU5N0ZFMDRDOTE5RTExRUE5NjIzRTU2OTQ2MEYzNzlFIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTk3RkUwNDk5MTlFMTFFQTk2MjNFNTY5NDYwRjM3OUUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTk3RkUwNEE5MTlFMTFFQTk2MjNFNTY5NDYwRjM3OUUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6zr8sUAAACL0lEQVR42mKcv27PfwYIeAbEG4B4ekKg8xUGKgLG/0AAYnz78ZPh0bPXDJduPWD49v1nK9CiGqrZ8h8N/Pj56/+Ow+f+A33YA7KfGpjh37///9Hxr99//m/adwpkUQmQz0AORraE8e+///+x+fDz1+8Mm/aeYPj77x9HXIDzT1JDiIkRiQ2yARvm4eZkUJGXAqlJxqUGH0axEOQPXFgZZgkeNbgwqiV4XCPIzwvykdGSjXuVaOYTEJaVFAOpC6aZT0AYbgklPiGkWliAj4GLg918+aa9MuTawkSMehmIb4LIjxOiLBGlzBJidIgICjBwsLPZr9y8V5xmwcXAyMggJQ72jT95PiESQFNZCDmFMBOx6V5EWJCBjZXVddWWvUJUzycwzAgOMhGQHj+aBRcISEtAkjLpwUVCshQTFWJgZWHxXbN1Lx/NfMLExMQgISYMYnqRpI/UigIaZCFUzyeoQSbMwMzMHLx2214umgQXCLAwMzOIi4KDzIP44CIDSEuIkpTKyLJEQkwElAii123by04zS4DJmEFMRAjEdKGZJQzg4l8cRIXT2BIxBl4e7lhgkKXRzBJQxjQz0AYl55lAi0JoYgkI8PPxMliZ6IOS9WqgRdk4W/Uff2BvppICPn35ynD6/BWGj5+/TAZ1PcJ8nK9T3RIQ+PfvH8P9R08Zbtx9wPDz5681QKEtQHwCiB8zvvv6hyqWwC0DuvnFq7cML1+/ZXj/4SMDGzsnA0CAAQBu0Hso39879AAAAABJRU5ErkJggg==);
        background-repeat: no-repeat;
        background-position: 6% 0, 96% 0;
        background-size: auto 100%;
    }

    #pageTab .ant-tabs-tab {
        margin-top: 2px;
        height: 26px;
        line-height: 26px;
        background: none;
        border: none;
        padding: 0 24px;
        -webkit-transition: none !important;
        transition: none !important;
    }

    #pageTab .ant-tabs-tab.ant-tabs-tab-active > div {
        position: relative;
        z-index: 5;
        height: 26px;
        min-width: 80px;
        border-top: 1px solid #9faebc;
        background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f1f8ff));
        background-image: linear-gradient(#fff, #f1f8ff);
        text-align: center
    }

    #pageTab .ant-tabs-bar {
        margin-bottom: 4px;
    }
</style>